import { Box, Grid, Typography } from "@mui/material";
import ProductsCard from "./ProductsCard";
import productData from "../data/productData";

const ProductList = () => {
  return (
    <Grid
      container
      component="section"
      role="region"
      aria-labelledby="most-efficient-products"
      sx={{ display: "block", color: "#000" }}
    >
      <Typography
        variant="h2"
        component="h2"
        id="most-efficient-products"
        sx={{
          color: "#3d4144",
          margin: "0 auto 2.5rem",
          maxWidth: "37.5rem",
          textAlign: "center",
          fontWeight: 700,
          lineHeight: 1.1,
          fontSize: "1.95rem",
          display: "block",
        }}
      >
        Products Recognized as ENERGY STAR Most Efficient in {import.meta.env.VITE_MOSTEFFICIENTYEAR}
      </Typography>
      <Grid container>
        {productData.map((product, index) => (
          <Grid item xs={12} sm={12} md={4} key={index}>
            <ProductsCard {...product} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default ProductList;
